'use client'

import {Menu} from 'antd'
import styled from 'styled-components'

import {StaticBasicStyles} from '../../shared/assets/styles/static'
import {ContentMainStyles} from '../../shared/ui/layout/ui/content.styles'

export const StaticStyledContent = styled.div`
  width: 100%;

  display: flex;
  flex-direction: column;

  ${StaticBasicStyles}
`

export const Main = styled.main`
  display: flex;
  flex-direction: row !important;
  align-items: flex-start !important;
  gap: 32px;
  width: 100%;

  ${ContentMainStyles}
`

export const StaticHead = styled.div`
  ${ContentMainStyles}

  flex: unset;
`

export const StaticMenu = styled(Menu)`
  padding: 10px;
`
